import React from 'react';
import './AvatarCard.css';

function AvatarCard({ avatarData, onRegenerate, index }) {
  const handleClick = () => {
    onRegenerate(index);
  };

  return (
    <div className="avatar-card" onClick={handleClick}>
      <div
        className="avatar-card-display"
        dangerouslySetInnerHTML={{ __html: avatarData.svg }}
      />
      <div className="avatar-card-overlay">
        <span className="regenerate-icon">🎲</span>
        <span className="regenerate-text">点击刷新</span>
      </div>
    </div>
  );
}

export default AvatarCard;
